import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const { user } = useSelector((state) => state.auth);
  const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 100);

  useEffect(() => {
    const updateHeight = () => {
      const availableHeight = window.innerHeight - 185;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  return (
    <div>
      <iframe
        src={
          user?.usrType === "SDI"
            ? `${url}/sdi_projects.php`
            : user?.usrType === "NIA"
            ? `${url}/nia_projects.php`
            : user?.usrType === "NWHSA"
            ? `${url}/nwhsa_projects.php`
            : ""
        }
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default LeafletMap;
